var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsTwo = function SvgSettingsTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "M2.918 14c0-5.225 0-7.838 1.623-9.46 1.623-1.624 4.236-1.624 9.46-1.624s7.837 0 9.46 1.623 1.624 4.236 1.624 9.46 0 7.837-1.623 9.46c-1.624 1.624-4.236 1.624-9.46 1.624s-7.838 0-9.46-1.623C2.917 21.836 2.917 19.224 2.917 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.75,
    d: "M9.918 11.666a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5ZM18.082 19.834a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.75,
    d: "M11.668 9.916h8.167M16.335 18.084H8.168"
  })));
};
export default SvgSettingsTwo;